import * as React from 'react';
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from '@material-ui/core/styles';
import MediaQuery from 'ha/helpers/MediaQuery';
import * as cx from 'classnames';

import units from 'ha/theme/units';
import SearchPager from 'ha/pages/Search/containers/SearchPager';
import SearchCategories from 'ha/pages/Search/containers/SearchCategories';

import Row from 'ha/ui/next/Row';
import Col from 'ha/ui/next/Col';

import { CopyText } from '../types';
import CityInfo from './CityInfo';
import SearchCollectionSubtitle from '../containers/SearchCollectionSubtitle';
import SearchCitiesNearby from '../containers/SearchCitiesNearby';
import SearchGuidesLinks from './SearchGuidesLinks';
import SearchPageBreadcrumbs from '../containers/SearchPageBreadcrumbs';

interface Props {
  cityCanonical?: string;
  countryCanonical?: string;
  shouldShowCitiesNearby: boolean;
  cityLocalizedName?: string;
  countryLocalizedName?: string;
  data: {
    cityPagePathname?: string;
    countryPagePathname?: string;
    copyText?: CopyText;
  };
}

const styles = (t: Theme) =>
  createStyles({
    seoMargin: {
      margin: units.yx(0.75, 0),
    },
    searchTips: {
      [t.breakpoints.down('sm')]: {
        padding: units.yx(0, 0.5),
      },
    },
  });

const SearchResultsBottom: React.SFC<Props & WithStyles<typeof styles>> = ({
  classes,
  data,
  cityLocalizedName,
  countryLocalizedName,
  shouldShowCitiesNearby,
  cityCanonical,
  countryCanonical,
}) => (
  <Row>
    <Col xs={12} className={classes.seoMargin}>
      <SearchPager />
    </Col>
    <MediaQuery>
      {({ lg }) =>
        !lg ? (
          <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
            <SearchPageBreadcrumbs
              withHomeItem
              withoutFirstSeparator
              withoutSpacing
            />
          </Col>
        ) : null
      }
    </MediaQuery>
    <Col xs={12} className={classes.searchTips}>
      <SearchCollectionSubtitle />
    </Col>
    {data.copyText && (
      <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
        <CityInfo text={data.copyText} />
      </Col>
    )}
    <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
      <SearchCategories />
    </Col>
    <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
      <SearchGuidesLinks
        cityCanonical={cityCanonical}
        countryCanonical={countryCanonical}
        cityLink={data.cityPagePathname}
        countryLink={data.countryPagePathname}
        cityLocalizedName={cityLocalizedName}
        countryLocalizedName={countryLocalizedName}
      />
    </Col>
    {shouldShowCitiesNearby && (
      <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
        <SearchCitiesNearby />
      </Col>
    )}
  </Row>
);

export default withStyles(styles)(SearchResultsBottom);
